export const KYC_DOCUMENTS_PER_PAGE = 10;
export const MAX_DOCUMENT_SIZE = 4.5;
